import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import getLabels from '../../utils/getLabels'

import Button from '../Button'

class SearchResultRow extends Component {
  hasAllotmentsLeft() {
    return (
      this.props.item.travelClassSeatCounts
        .map(travelClassSeatCount => travelClassSeatCount.availableSeatCount)
        .reduce((a, b) => a + b, 0) !== 0
    )
  }

  render() {
    const {
      classes,
      item,
      isActive,
      onAddPassenger,
      flightIsSelected,
    } = this.props

    const editBookingPageBaseUrl = 'edit_booking'

    return (
      <div
        className={classNames(classes.row, {
          [classes.rowSelected]: isActive,
        })}
        data-element="search-result-row"
      >
        <div className={classes.cel} data-element="select-result-flight-id">
          {item.flightId.substr(14)}
        </div>

        <div className={classes.cel}>{item.flightInfo.departureTime}</div>
        <div className={classes.cel}>{item.flightInfo.arrivalTime}</div>

        <div className={classes.cel}>
          {item.travelClassSeatCounts.map(seats => (
            <span
              className={classes.seatType}
              key={classes.seatType}
              data-element="select-result-available-seat-count"
            >{`${seats.availableSeatCount} ${seats.travelClass}`}</span>
          ))}
        </div>

        <div className={classNames(classes.cel, classes.lastCel)}>
          <Link
            to={`/${editBookingPageBaseUrl}/${item.flightId}`}
            data-element="select-result"
          >
            <Button className={classes.button} color="white">
              {getLabels('select')}
            </Button>
          </Link>

          <Button
            onClick={() => {
              onAddPassenger(item)
            }}
            data-element="add-passengers"
            color={flightIsSelected ? 'blue' : 'green'}
            isDisabled={!this.hasAllotmentsLeft()}
          >
            {getLabels('add_passengers')}
          </Button>
        </div>
      </div>
    )
  }
}

SearchResultRow.propTypes = {
  classes: PropTypes.shape({
    button: PropTypes.string,
    icon: PropTypes.string,
    seatType: PropTypes.string,
    row: PropTypes.string,
    rowSelected: PropTypes.string,
    cel: PropTypes.string,
    lastCel: PropTypes.string,
  }),
  item: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  onAddPassenger: PropTypes.func,
  flightIsSelected: PropTypes.bool,
}

export default SearchResultRow
